import { useState, useCallback } from 'react';
import Preloader from './components/Preloader';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HighlightsCarousel from './components/HighlightsCarousel';
import About from './components/About';
import RaioXMetabolico from './components/RaioXMetabolico';
import AreasAtuacao from './components/AreasAtuacao';
import ComoFunciona from './components/ComoFunciona';
import Diferenciais from './components/Diferenciais';
import Depoimentos from './components/Depoimentos';
import InstagramSection from './components/InstagramSection';
import Clinica from './components/Clinica';
import FAQ from './components/FAQ';
import CTAFinal from './components/CTAFinal';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';

export default function Home() {
  const [preloaderDone, setPreloaderDone] = useState(false);

  const handlePreloaderComplete = useCallback(() => {
    setPreloaderDone(true);
  }, []);

  return (
    <>
      {/* Grain overlay */}
      <div className="grain-overlay" />

      {/* Preloader */}
      {!preloaderDone && <Preloader onComplete={handlePreloaderComplete} />}

      {/* Main content */}
      <div
        className={`transition-all duration-1000 ease-out ${
          preloaderDone ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <Navbar />
        <Hero />
        <HighlightsCarousel />
        <About />
        <RaioXMetabolico />
        <AreasAtuacao />
        <ComoFunciona />
        <Diferenciais />
        <Depoimentos />
        <InstagramSection />
        <Clinica />
        <FAQ />
        <CTAFinal />
        <ContactSection />
        <Footer />
        <FloatingWhatsApp />
      </div>
    </>
  );
}